import React, { createContext, useReducer, useEffect } from 'react';

import { loadState, saveState } from '@utils/localStorage';

import reducer from './reducer';

const persistedState = loadState();

const initialState = {
  bookId: null,
  currentPage: 0,
  pagesCount: 0,
  isMainMenuSidebarOpened: false,
  isTOCSidebarOpened: false,
  isThumbnailsSidebarOpened: false,
  isBookmarksSidebarOpened: false,
  isSettingsDropdownOpened: false,
  isSpeechDropdownOpened: false,
  isSearchSidebarOpened: false,
  isBetaModalOpened: false,
  isEditorCookieOpened: false,
  activeTheme: 0,
  zoomScale: 1,
  rotatePage: 0,
  selectDoc: null,
  sidebarWidth: '328px',
  isLeftMargin: 0,
  isOnShelf: false,
  isUserLoggedIn: false,
  isUserTargetAudience: null,
  isLoginModalVisible: true,
  isLoginModalWobbled: false,
  isBookmarkModalShown: false,
  isEditorModalShownText: null,
  isEditorModalShown: false,
  shouldShowAddedToBookmark: false,
  isShelfModalShown: false,
  isSinglePageMode: true,
  searchQuery: '',
  wv: Math.max(
    document.documentElement.clientWidth || 0,
    window.innerWidth || 0,
  ),
  pairsPagesHtmlUrls: [],
  efedNoAuth: false,
  bookIsEligibleForAiTools: false,
  speechState: 'STOPPED',
  speechSpeed: 1.0,
  speechSpeaker: 'male_1',
};

const Store = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, {
    ...initialState,
    ...persistedState,
  });

  useEffect(() => {
    saveState({
      isSinglePageMode: state.isSinglePageMode,
      activeTheme: state.activeTheme,
    });
  }, [state.activeTheme, state.isSinglePageMode]);

  return (
    <Context.Provider value={[state, dispatch]}>{children}</Context.Provider>
  );
};

export const Context = createContext(initialState);
export default Store;
